import dispatcher from "../dispatcher"
import * as api from "../api"
import { IEmployeeWorkFlow } from "../models"

export function fetchUserWorkflows(loggedInUserId) {
    dispatcher.dispatch({ type: "START_LOADING_WORKFLOW", value: true })
    return new Promise((resolve, reject) => {
        api.getUserWorkflows(loggedInUserId).then(result => {
            recieveWorkflowData(result.data)
            dispatcher.dispatch({ type: "START_LOADING_WORKFLOW", value: false })
            resolve(result.data)
        })
    })
}

function recieveWorkflowData(data: IEmployeeWorkFlow[]) {
    const accountSetupEmployeeWorkflow = data.find(item => item.Workflow.SystemId === "ACCOUNT_SETUP")
    if (accountSetupEmployeeWorkflow) {
        dispatcher.dispatch({ type: "RECEIVE_ACCOUNT_SETUP_WORKFLOW", workflow: accountSetupEmployeeWorkflow.Workflow })
    }
    dispatcher.dispatch({ type: "RECEIVE_WORKFLOWS", data })
}